import IGenericResult from "@/interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
import { IWhiteLabelReturn } from "@/interfaces/IWhiteLabel";

class RelatorioService {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.relatorio}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getAllRelatorioTipo() {
        return await api.get<IGenericResult[]>(`${resources.relatorio}/GetAllRelatorioTipo`);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.relatorio}/Delete/${id}`);
    }

    async download(filters: any) {
        return await api.get<string>(`${resources.relatorio}/Download/${ToQueryString(filters)}`);
    }

    async upload(data: any) {
        return await api.post<string>(`${resources.relatorio}/Upload`, data);
    }

    async getRelatorioFaturaConcessionaria(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFaturaConcessionaria/${ToQueryString(filters)}`);
    }

    async getRelatorioStatusUsina(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioStatusUsina/${ToQueryString(filters)}`);
    }

    async getRelatorioHistoricoConsumo(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioHistoricoConsumo/${ToQueryString(filters)}`);
    }

    async getRelatorioMovimentacoesCliente(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioMovimentacoesCliente/${ToQueryString(filters)}`);
    }

    async getRelatorioFaturaPendente(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFaturaPendente/${ToQueryString(filters)}`);
    }

    async getRelatorioFaturasCliente(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFaturasCliente/${ToQueryString(filters)}`);
    }

    async getRelatorioVencimentoFatura(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioVencimentoFatura/${ToQueryString(filters)}`);
    }

    async getRelatorioCredito(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioCredito/${ToQueryString(filters)}`);
    }

    async getRelatorioGeral(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioGeral/${ToQueryString(filters)}`);
    }

    async getBalancoCredito(filters: any) {
        return await api.get(`${resources.relatorio}/GetBalancoCredito/${ToQueryString(filters)}`);
    }

    async getRelatorioFaturamentoUsina(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFaturamentoUsina/${ToQueryString(filters)}`);
    }

    async getRelatorioRefaturamento(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioRefaturamento/${ToQueryString(filters)}`);
    }

    async getRelatorioFormasFaturamento(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFormasFaturamento/${ToQueryString(filters)}`);
    }

    async getRelatorioDeducaoAcrescimo(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioDeducaoAcrescimo/${ToQueryString(filters)}`);
    }

    async getRelatorioInstalacaoCancelada(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioInstalacaoCancelada/${ToQueryString(filters)}`);
    }

    async getRelatorioConsolidadoProvisao(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioConsolidadoProvisao/${ToQueryString(filters)}`);
    }

    async getRelatorioGeracaoUsina(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioGeracaoUsina/${ToQueryString(filters)}`);
    }

    async getRelatorioPosVendaComercial(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioPosVendaComercial/${ToQueryString(filters)}`);
    }

    async getFaturamentoGerencial(filters: any) {
        return await api.get(`${resources.relatorio}/FaturamentoGerencial/${ToQueryString(filters)}`);
    }

    async getRelatorioUsinasRebalance(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioUsinasRebalance/${ToQueryString(filters)}`);
    }

    async getRelatorioFaturasChurn(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioFaturasChurn/${ToQueryString(filters)}`);
    }

    async getRelatorioResumoFaturamento(filters: any) {
        return await api.get(`${resources.relatorio}/GetRelatorioResumoFaturamento/${ToQueryString(filters)}`);
    }

    async getRelatorioParametrizacaoRebate(filters: any) {
        return await api.get(`${resources.relatorio}/ParametrizacaoRebate${ToQueryString(filters)}`);
    }

    async getRelatorioCalculoRebate(filters: any) {
        return await api.get(`${resources.relatorio.toLowerCase()}/rebateusinainstalacao${ToQueryString(filters)}`);
    }

    async getRelatorioBonificacao(filters: any) {
        return await api.get(`${resources.relatorio.toLowerCase()}/bonificacao${ToQueryString(filters)}`);
    }

    async getRelatorioParametrizacao(filters: any) {
        return await api.get(`${resources.relatorio.toLowerCase()}/parametrizacao${ToQueryString(filters)}`);
    }
    async getRelatorioConsolidacaoCliente(filters: any) {
        return await api.get(
            `${resources.relatorio.toLowerCase()}/rebalanceconsolidacaocliente${ToQueryString(filters)}`
        );
    }

    async getByAllRelatorioTipoId() {
        return await api.get(
            `${resources.relatorio.toLowerCase()}/getbyallbyrelatoriotipoid`
        )
    }

    //White Label, relatorio parametrizado
    async postRelatorioPersonalizado(data: any) {
        return await api.post(`${resources.relatorioWhiteLabel}/create`, data);
    }
    async getRelatorioPersonalizado() {
        return await api.get<IWhiteLabelReturn[]>(`${resources.relatorioWhiteLabel}/1`);
    }
    async deleteRelatorioPersonalizado(id: string) {
        return await api.delete(`${resources.relatorioWhiteLabel}/${id}`);
    }
}

export default new RelatorioService();
